module.exports = __webpack_public_path__ + "media/footer/instagram-5555ec24.svg";